import React from "react";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import LandingPage from "modules/LandingPage";
import { Login } from "modules/auth";
import { AdminLayout, LandingLayout } from "layouts";
import { useSelector } from "react-redux";
import { AdminEmployees, AdminDrivers, AdminOrders, AdminServicePoints, AdminSlider, AdminUsers, AdminUserDetails, AdminSubscribers, FrequentlyAskedQuestions, Notifications, PromoCodes, AdminOrderDetails } from "modules/admin";
import { About, PrivacyPolicy, Settings, TermsAndConditions } from "modules/admin/Settings";
import { ErrorRoutePageHandler } from "modules/common";

export default function Router() {
    const { isAuth } = useSelector(state => state.auth)

    const router = createBrowserRouter([
        {
            path: "",
            element: <LandingLayout />,
            errorElement: <ErrorRoutePageHandler /> ,
            children: [
                { path: "", element: <LandingPage /> },
            ]
        },
        { path: "terms_and_conditions", element: <TermsAndConditions />, errorElement: <ErrorRoutePageHandler /> , },
        { path: "privacy_policy", element: <PrivacyPolicy />, errorElement: <ErrorRoutePageHandler /> , },
        { path: "about", element: <About />, errorElement: <ErrorRoutePageHandler /> , },
        {
            path: "admin",
            element: isAuth ? <AdminLayout /> : <Navigate to="/auth/login" replace />,
            errorElement: <ErrorRoutePageHandler /> ,
            children: [
                { path: "", element: <AdminUsers /> },
                { path: "user/:id", element: <AdminUserDetails /> },
                { path: "drivers", element: <AdminDrivers /> },
                { path: "employees", element: <AdminEmployees /> },
                { path: "orders", element: <AdminOrders /> },
                { path: "order/:id", element: <AdminOrderDetails /> },
                { path: "slider", element: <AdminSlider /> },
                { path: "service_points", element: <AdminServicePoints /> },
                { path: "subscribers", element: <AdminSubscribers /> },
                { path: "faq", element: <FrequentlyAskedQuestions /> },
                { path: "notifications", element: <Notifications /> },
                { path: "promos", element: <PromoCodes /> },
                {
                    path: "settings",
                    errorElement: <ErrorRoutePageHandler /> ,
                    children: [
                        { path: "", element: <Settings /> },
                        { path: "terms_and_conditions", element: <TermsAndConditions type="EDIT" /> },
                        { path: "privacy_policy", element: <PrivacyPolicy type="EDIT" /> },
                        { path: "about", element: <About type="EDIT" /> },
                    ]
                }
            ]
        },
        {
            path: "auth",
            element: isAuth && <Navigate to="/" replace />,
            children: [
                { path: "login", element: <Login /> },
            ]
        },
        { path: "*", element: <Navigate to="/" /> },
    ]);
    return (
        <RouterProvider router={router} />
    )
}